'use strict';

class BetaProgram {
  constructor($sce, $http) {
    this.$sce = $sce;
    this.$http = $http;
  }

  $onInit() {
    this.features = [];

    this.$http.get(`/internal/features/beta`)
      .then((resp) => {
        resp.data.featuresInBeta.map(f => {
          if (f.norwegianName) {
            f.description = this.$sce.trustAsHtml(f.description);
            this.features.push(f);
          }
        }, this);
      });
  }
}

BetaProgram.$inject = ['$sce', '$http'];

const betaProgram = {
  controller: BetaProgram,
  template: `
    <h2>Velkommen til SendRegnings Beta-program</h2>

    <p>
      Vi utvikler stadig nye funksjoner, og vi setter pris på at du har sagt deg villig til å hjelpe oss å teste dem, som en del av vårt beta-program.
      Beta-programmet fungerer ved at utvalgte kunder får tilgang til nye funksjoner før alle andre og får mulighet til å gi oss tilbakemeldinger på hva som er bra, mindre bra, eller mangler helt.
    </p>
    <p>
      Som en beta-bruker får du anledning til å sende tilbakemeldinger direkte til utviklerne ved hjelp av e-posten <a href="mailto:beta@sendregning.no">beta@sendregning.no</a>.
      Fra tid til annen kan det også hende at vi tar kontakt med deg i forbindelse med en bestemt funksjon.
      Merk at <a href="mailto:beta@sendregning.no">beta@sendregning.no</a> er tiltenkt tilbakemeldinger på nye funksjoner, det er ingen garantert svartid,
      så hvis du opplever tekniske problemer er det fortsatt best å kontakte oss på <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a>
    </p>

    <h3 class="subheader">Beta-funksjoner akkurat nå</h3>
    <p>Følgende funksjoner er nå tilgjengelig for testing av beta-brukere:</p>

    <fieldset ng-repeat="feature in $ctrl.features track by $index">
      <h3 class="subheader">{{ feature.norwegianName }}</h3>
      <p ng-bind-html="feature.description"></p>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('betaProgram', betaProgram)
  .config(($routeProvider) => {
    $routeProvider
      .when('/beta', {
        title: 'Velkommen til SendRegnings Beta-program',
        template: '<beta-program />',
        secure: true
      });
  });
